import { Product, ProductVariation, ProductCategory } from '../types';
import { api } from '../../../services/api/axios';

export const productsService = {
    getCategoryBySlug: async (slug: string): Promise<ProductCategory> => {
        try {
            const response = await api.get('/products/categories', {
                params: { slug },
            });
            return response.data[0];
        } catch (err: any) {
            const apiMessage = err.response?.data?.message || err.response?.data?.error;
            throw new Error(apiMessage || err.message);
        }
    },

    getAllProducts: async (params?: {
        _fields?: string;
        per_page?: number;
        page?: number;
        category?: string;
        tag?: string;
        exclude?: string;
        search?: string;
        orderby?: string;
        order?: 'asc' | 'desc';
    }): Promise<Product[]> => {
        try {
            const response = await api.get('/products', { params });
            return response.data;
        } catch (err: any) {
            const apiMessage = err.response?.data?.message || err.response?.data?.error;
            throw new Error(apiMessage || err.message);
        }
    },

    getProduct: async (
        id: number | string,
        params?: { _fields?: string; }
    ): Promise<Product> => {
        try {
            const response = await api.get(`/products/${id}`, { params });
            return response.data;
        } catch (err: any) {
            const apiMessage = err.response?.data?.message || err.response?.data?.error;
            throw new Error(apiMessage || err.message);
        }
    },

    getProductVariations: async (
        productId: number | string,
        params?: { _fields?: string; }
    ): Promise<ProductVariation[]> => {
        try {
            const response = await api.get(`/products/${productId}/variations`, { params: { per_page: 50, ...params } });
            return response.data;
        } catch (err: any) {
            const apiMessage = err.response?.data?.message || err.response?.data?.error;
            throw new Error(apiMessage || err.message);
        }
    },
}
